import MessageModel from '../../Models/messages/MessageModel'
import BaseCollection from '../../../lib/data/Collections/BaseCollection'
import SocketCommand from '../../SocketCommand'
import moment from 'moment/moment'

export default class MessageCollection extends BaseCollection {
  constructor(items = []) {
    super(items, MessageModel)
  }

  boot() {
    super.boot()

    this.fetchCommand = SocketCommand.Message.All
  }

  /* PROPERTIES */

  /* METHODS */

  filteredAndGrouped(filterByProperty, groupByProperty) {
    const filterResults = filterByProperty === '' ? this : this.filter(message => message.Type.GroupId.toString() === filterByProperty.toString())

    const unsortedObj = filterResults.reduce(
      (objectsByKeyValue, obj) => {
        const keyValue = groupByProperty.split('.').reduce((o, i) => o[i], obj)

        return ({
          ...objectsByKeyValue,
          [keyValue]: (objectsByKeyValue[keyValue] || []).concat(obj)
        })
      },
      {}
    )

    const sortedKeys = Object.keys(unsortedObj).sort((a, b) => {
      const now = new Date().getTime()

      const sinceA = moment(a, 'DD-MM-YYYY').subtract(moment().days())
      const sinceTimeA = new Date(sinceA).getTime()
      const secondsA = now / 1000 - sinceTimeA / 1000

      const sinceB = moment(b, 'DD-MM-YYYY').subtract(moment().days())
      const sinceTimeB = new Date(sinceB).getTime()
      const secondsB = now / 1000 - sinceTimeB / 1000

      return secondsA > secondsB ? 1 : -1
    })

    const sortedObj = {}
    sortedKeys.forEach(key => {
      sortedObj[key] = unsortedObj[key]
    })

    return sortedObj
  }

  /* API METHODS */

  onFetch(data) {
    if (data.Messages) super.onFetch(data.Messages)
    if (data.hasOwnProperty('Groups')) window.Vue.$DataStore.messages.groups.clear().add(data.Groups)
  }
}
